var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui menu"},[_c('Logo'),_vm._v(" "),_c('div',{staticClass:"right menu"},[_c('div',{staticClass:"item"},[_c('button',{staticClass:"ui basic button"},[_c('router-link',{attrs:{"to":"/Admin"}},[_vm._v("Admin")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8fdac92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menubar.vue
// module id = 103
// module chunks = 0